import { Injectable } from '@angular/core';
import { ClientService } from '../../../shared/services/client.service';


@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(private clientService: ClientService) {}

  temaImagemPadrao = {
    corPrimaria: '#F37E65',
    corSecundaria: '#E82C5D',
    corTerciaria: '#FEEFEA',
    logo: 'logo-padrao.png'
  };

  applyTheme() {
    const data = this.clientService.getDadosCliente();
    
    if (data && data.tema) {
      const root = document.documentElement;
      const { corPrimaria, corSecundaria, corTerciaria } = data.tema;

      root.style.setProperty('--primary', corPrimaria);
      root.style.setProperty('--primary-light', corSecundaria);
      root.style.setProperty('--primary-dark', corTerciaria);
    }

    else {
      const root = document.documentElement;

      root.style.setProperty('--primary', this.temaImagemPadrao.corPrimaria);
      root.style.setProperty('--primary-light', this.temaImagemPadrao.corSecundaria);
      root.style.setProperty('--primary-dark', this.temaImagemPadrao.corTerciaria);
    }
  }

  getLogo(): string {
    const data = this.clientService.getDadosCliente();
    return data ? data.logotipoUrl : this.temaImagemPadrao.logo;
  }
}